
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getIpoList } from './client/ipos';
import { mapPaginatorData } from '../utils/data-mappers';

export const useIpoQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.IPOS, params],
    queryFn: () => getIpoList.all( params ),
    keepPreviousData: true,
  });
  console.log("Ipo list data:", data?.upcoming);
  return {
    upcoming: data?.upcoming,
    listed:data?.listed,
    active:data?.active,
    closed:data?.closed,
    error,
    isLoading,
  };
};
